/* LIVE COPY: snippets/enso-js-pdp-buybox.liquid, inlined by snippets/enso-pdp-early.liquid so it runs
   during parsing (30 Sep 2026). assets/enso-pdp-buybox.js is a byte copy (themeFilesCopy snippet -> asset after
   every edit); layout still loads it deferred, where it returns at once after the early run. */
/* ENSO — concept-PDP buy box adjustments (12 Sep 2026)
   sections/enso-pdp-concept.liquid is 94 KB and cannot be written by API,
   so these are DOM moves from a product-only asset. Styles:
   assets/enso-pdp-buybox.css. Elements are moved, never cloned, so the
   section's own listeners (#epcMinus / #epcPlus / .epc__cta) keep working.
   1. Quantity stepper sits beside "Add to bag" in one row (.epc__ctarow).
   2. Payment marks (.epc__secure) sit directly under that row, centred.
   3. Phone-only delivery line under the price (.epc__shipline), built from
      the estimated-arrival dates the buy box already renders.
   4. Downlights: cut-out replaces height in the meta row (.epc__cutout).
   5. Integrated LED: wattage + lumens in the "LED included" fact.
   6. Recessed downlights: band 02 copy + "try the size" tip use the cut-out.
   (The 2700K chip on the hero is hidden on phones by CSS alone.) */
(function () {
  // 30 Sep 2026: window.__ensoRunNow is set by snippets/enso-pdp-early.liquid, which runs this
  // code while the page is still parsing (the moment .epc__secure exists), so the buy box is laid
  // out before the first paint instead of jumping after it.
  function ready(fn) {
    if (window.__ensoRunNow || document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    var q = function (s, r) { return (r || document).querySelector(s); };
    var cta = q('.epc__cta');
    if (!cta || cta.closest('.epc__ctarow')) return;

    /* 1. stepper next to the CTA */
    var qtyrow = q('.epc__qtyrow');
    var stepper = qtyrow ? q('.epc__stepper', qtyrow) : null;
    var row = document.createElement('div');
    row.className = 'epc__ctarow';
    cta.parentNode.insertBefore(row, cta);
    if (stepper) { row.appendChild(stepper); qtyrow.classList.add('is-empty'); }
    row.appendChild(cta);

    /* 2. payment marks under the row */
    var secure = q('.epc__secure');
    if (secure) { row.insertAdjacentElement('afterend', secure); secure.classList.add('is-moved'); }

    /* 4. downlights: the meta row says the cut-out, not the height
          (Mike, 12 Sep: "the cutout is the most important information for
          downlights"). snippets/epc-keys.liquid emits a hidden .epc__cutout
          span from custom.cut_out_mm; we swap the "N cm tall" text for it. */
    var co = q('.epc__cutout'), meta = q('.epc__meta');
    if (co && meta) {
      var label = co.textContent.trim(), swapped = false;
      Array.prototype.forEach.call(meta.childNodes, function (n) {
        if (n.nodeType === 3 && /cm tall/.test(n.textContent)) { n.textContent = label; swapped = true; }
      });
      if (!swapped) {
        var jump = q('.epc__jump', meta), sep = document.createElement('i');
        sep.textContent = '|';
        meta.insertBefore(sep, jump);
        meta.insertBefore(document.createTextNode(label), jump);
      }
    }

    /* 5. integrated LED: the "LED included" fact carries the wattage and
          output ("Integrated 7 W LED · 600 lm") — Mike, 12 Sep: "wattage is
          also important for integrated led fittings". Text comes from the
          hidden .epc__wattfact span emitted by snippets/epc-keys.liquid. */
    var wf = q('.epc__wattfact');
    if (wf) {
      var lis = document.querySelectorAll('.epc__facts li');
      for (var i = 0; i < lis.length; i++) {
        if (/LED included/.test(lis[i].textContent)) {
          var tn = lis[i].lastChild;
          if (tn && tn.nodeType === 3) tn.textContent = wf.textContent.trim();
          break;
        }
      }
    }

    /* 3. delivery line under the price (shown on phones only, see CSS) */
    var head = q('.epc__head');
    var eta = q('.epc__eta b');
    if (head && !q('.epc__shipline')) {
      var when = eta ? eta.textContent.replace(/\s+/g, ' ').trim() : '';
      var p = document.createElement('p');
      p.className = 'epc__shipline';
      p.innerHTML =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true">' +
        '<path d="M3 7h11v9H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="17" r="1.5"/><circle cx="17" cy="17" r="1.5"/></svg>' +
        '<span><em>Free UK delivery over £40</em>' + (when ? ' · arrives ' + when : '') + '</span>';
      head.insertAdjacentElement('afterend', p);
    }
  });

  /* Step 6 needs the bands below the buy box, which are parsed after it — so it always waits for
     DOMContentLoaded, even when the rest ran early. Once per page. */
  function band6() {
    if (window.__ensoBand6) return;
    window.__ensoBand6 = true;
    var q = function (s, r) { return (r || document).querySelector(s); };
    /* 6. recessed downlights: band 02 "Find its place" is written for
          pendants ("anchor a table", "mark a N cm circle on the floor").
          snippets/epc-keys.liquid emits .epc__fitbody and .epc__fittip for
          products with custom.cut_out_mm; swap them in. (Google review, 12 Sep.) */
    var fb = q('.epc__fitbody'), ft = q('.epc__fittip');
    if (fb || ft) {
      var nos = document.querySelectorAll('.epc__words .epc__no');
      for (var k = 0; k < nos.length; k++) {
        if (/find its place/i.test(nos[k].textContent)) {
          var words = nos[k].parentNode;
          var body = q('.epc__body', words), tip = q('.epc__tip', words);
          if (fb && body) body.textContent = fb.textContent.trim();
          if (ft && tip) { var tp = tip.querySelector('p:not(.epc__tiph)'); if (tp) tp.textContent = ft.textContent.trim(); }
          break;
        }
      }
    }

  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', band6);
  else band6();
})();
